module.exports = __webpack_public_path__ + "static/img/manual_ja_11.98344f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_11.png
// module id = MecR
// module chunks = 4